module.exports = __webpack_public_path__ + "static/media/uom_logo.ee402aed.png";